<template>
    <div class="wtw-container birth-container">
      <div class="flex-grid">
        <div class="select-wrapper" :class="{'select-wrapper--value-selected': birth.month}">
          <select name="month" v-model="birth.month" class="birth-select">
            <option :value="null">Month</option>
            <option v-for="month in months" :key="month.value" :value="month.value">{{month.name}}</option>
          </select>
        </div>
        <div class="select-wrapper" :class="{'select-wrapper--value-selected': birth.day}">
          <select name="day" v-model="birth.day" class="birth-select" :disabled="!birth.month">
            <option :value="null">Day</option>
            <option v-for="day in month.days" :key="day" :value="day">{{day}}</option>
          </select>
        </div>
        <div class="select-wrapper" :class="{'select-wrapper--value-selected': birth.year}">
          <select name="year" v-model="birth.year" class="birth-select">
            <option :value="null">Year</option>
            <option v-for="year in years" :key="year" :value="year">{{year}}</option>
          </select>
        </div>
      </div>
      <span v-show="age !== null && age !== undefined && age < 18" class="error-message">You must be 18 or older to use this app.</span>
    </div>
</template>

<script>
    import months from '../../../utilities/months'
    import $ from 'webpack-zepto';

    export default{
        data() {
            return {
                option: null,
                canGoToNextStep: true,
                birth: {
                  year: null,
                  month: null,
                  day: null
                },
                months: months
            }
        },
        props:['options', 'sendOptions', 'optionsAll', 'optionsSelected', 'extraData'],
        computed: {
          years () {
            const year = new Date().getFullYear()
            return Array.from({length: year - 1900}, (value, index) => year - index)
          },
          month() {
            return this.months.filter(month => month.value === this.birth.month).shift() || {days: 0}
          },
          age() {
            return this.birth.year &&
              this.birth.month &&
              this.birth.day &&
              parseInt((new Date() - new Date(this.birth.year, this.birth.month - 1, this.birth.day))/(1000*60*60*24*365));
          }
        },
        created(){
          if(this.extraData) {
            this.birth = this.extraData;
          }
        },
        methods:{
        },
        watch: {
          sendOptions() {
              if (this.sendOptions) {
                  if(this.age && this.age >= 18){
                    let optionIds = this.options.map((option) => {
                        return option.product_option_value_id;
                    });
                    if(this.$parent.getNoSkip) {
                        this.option = (this.options.find(option => {
                          const ageOpts = option.product_option_value_title.split('-');
                          if(ageOpts.length >= 2){
                            return parseInt(ageOpts[0]) <= this.age
                              && this.age <= parseInt(ageOpts[1]);
                          }else {
                            return parseInt(ageOpts[0]) <= this.age;
                          }
                        }) || {}).product_option_value_id;
                        this.canGoToNextStep = this.option ? true : false;
                    } else {
                        this.canGoToNextStep = true
                    }
                    // prevent duplicates in selected array
                    this.$parent.$emit('removeOptions', optionIds);
                  }else{
                    this.canGoToNextStep = false;
                  }
                  this.$parent.$emit('optionsSending', [this.option], this.canGoToNextStep, this.birth);
              }
          }
        }
    }
</script>